import script from "./AcceptDeleteAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./AcceptDeleteAccount.vue?vue&type=script&setup=true&lang=js"

import "./AcceptDeleteAccount.vue?vue&type=style&index=0&id=fcead01e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcead01e"]])

export default __exports__